<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { permissions } from "./permissions";
import { mapActions, mapGetters } from "vuex";

/**
 * Cards component
 */
export default {
  page: {
    title: "User Permissions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "User Permissions",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Roles",
          href: "/users/roles",
        },
        {
          text: "User Permissions",
          active: true,
        },
      ],
      permissions: permissions,
      userData: {
        permissions: {},
      },
    };
  },
  computed: {
    ...mapGetters("users", ["AllRoles", "SaveStatus"]),
    ...mapGetters("auth", ["RolePermissions", "getCurrentUser"]),
  },
  watch: {
    // SaveStatus(newVal) {
    //   if (!newVal) {
    //     this.resetError();
    //     // this.closeModal(this.modal);
    //   }
    // },
  },
  methods: {
    ...mapActions({
      SubmitPermissionsAction: "auth/submitPermissionsAction",
      FetchPermissions: "auth/fetchPermissions",
      FetchRolePermissions: "auth/fetchRolePermissions",
    }),

    //when permission is checked
    permissionChecked(event) {
      const parent = event.target.getAttribute("parent");
      const permission = event.target.value;
      const permissionData = {
        role: this.$route.params.id,
        parent,
        permission,
      };
      this.SubmitPermissionsAction(permissionData);
    },
  },
  created() {
    this.FetchPermissions();
    this.FetchRolePermissions({ role: this.$route.params.id });
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('assign_permissions')
        )
      "
    >
      <div
        class="col-md-12"
        v-for="(permission, index) in permissions"
        :key="index"
      >
        <b-card no-body>
          <b-card-body>
            <b-card-title>
              <div class="form-group form-check">
                <label class="card-title form-check-label" :for="index">{{
                  permission.parent.name
                }}</label>
              </div>
            </b-card-title>
            <hr />
            <div class="row">
              <b-card-text
                class="col-md-4"
                v-for="(childPermission, childIndex) in permission.permissions"
                :key="childIndex"
              >
                <div class="form-group form-check">
                  <input
                    type="checkbox"
                    @input="permissionChecked($event)"
                    :id="childPermission.value"
                    :value="childPermission.value"
                    :parent="permission.parent.value"
                    :checked="
                      RolePermissions.find((item) =>
                        item.permission.includes(childPermission.value)
                      )
                        ? true
                        : false
                    "
                    class="form-check-input form-control-md"
                  />
                  <label
                    class="form-check-label"
                    :for="childPermission.value"
                    >{{ childPermission.name }}</label
                  >
                </div>
              </b-card-text>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
